import { useState } from "react";
import { FileText, CheckCircle2, RefreshCw } from "lucide-react";
import CvSourceTabs from "../app/CvSourceTabs";
import { StepNav } from "./Stepper";

export default function StepCv({ baseCv, locked, onCvChange, onNext }) {
  const [replace, setReplace] = useState(false);
  return (
    <div className="af-fade-up" data-testid="studio-step-cv">
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-ink">{baseCv ? "Your CV is ready" : "Start with your CV"}</h1>
      <p className="text-body mt-2 mb-6 max-w-2xl">
        {baseCv ? "We'll tailor this CV to the job. You only add it once; every application starts from it." : "Upload the CV you already have, or create one from your LinkedIn profile. We'll keep it safe and use it for every application."}
      </p>
      {baseCv ? (
        <div className="gi-card p-5" data-testid="studio-current-cv">
          <div className="flex flex-wrap items-center gap-4">
            <div className="w-11 h-11 rounded-xl bg-brand-soft flex items-center justify-center"><FileText className="w-5 h-5 text-brand" /></div>
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-ink truncate flex items-center gap-2">{baseCv.original_filename} <CheckCircle2 className="w-4 h-4 text-success shrink-0" aria-label="Saved" /></div>
              <div className="text-sm text-faint">Saved {String(baseCv.created_at || "").slice(0, 10)}{baseCv.source === "linkedin" ? " · built from LinkedIn" : ""}</div>
            </div>
            {!locked && (
              <button data-testid="studio-replace-toggle" onClick={() => setReplace((v) => !v)} aria-expanded={replace} className="gi-btn gi-btn-secondary gi-btn-sm">
                <RefreshCw className="w-4 h-4" /> Use a different CV
              </button>
            )}
          </div>
          {replace && !locked && (
            <div className="mt-4 pt-4 border-t border-line">
              <CvSourceTabs compact testid="studio-replace-cv" uploadLabel="Choose your new CV" onDone={async () => { await onCvChange(); setReplace(false); }} />
            </div>
          )}
        </div>
      ) : (
        <CvSourceTabs testid="studio-cv-source" onDone={async () => { await onCvChange(); onNext(); }} />
      )}
      {locked && <p className="mt-3 text-sm text-faint">This application was made from the CV above. Replacing your CV only affects new applications. You can do that from My CV.</p>}
      <StepNav onNext={baseCv ? onNext : null} nextLabel="Continue to the job" />
    </div>
  );
}
